import React, { Component } from 'react';

class Landing extends Component {
  render() {
    return (
      <div className="landing container">
        <h1>Landing</h1>
        <p>
          The Landing Page is open to everyone, even though the user
          isn't signed in.
        </p>
      </div>
    );
  }
}

export default Landing;
